<template>
    <div class="faceCourseAllCont">
        <div class="compulsoryCourseCont" v-show="isShowFaceSelcetAddressFlag">
            <p class="compulsoryCourseTitle">请选择上课地点</p>
            <ul class="faceCourseAddressList">
                <li v-for="(item, idx) in faceCourseAddress" :key="idx" class="textCut" @click="jumpSelectClasses()">
                    {{item.address}}
                </li>
            </ul>
        </div>

        <div class="compulsoryCourseCont" v-show="isShowFaceSelectClassesFlag">
            <p class="compulsoryCourseTitle">请选择班次</p>
            <ul class="compulsoryCourseList selectClassesList">
                <li>
                    <div class="compulsoryCourseImgInfor">
                        <p class="compulsoryCourseImgTitle textCut">第一期</p>
                        <p class="compulsoryCourseScore">开课时间：2020-05-26 13:00 </p>
                        <p class="compulsoryCourseScore">授课地点：湖南省长沙市医药大学浦东校区学士路</p>
                    </div>

                    <div class="studenInterest">
                        <span class="blueGradient">立即报名</span>
                        <span class="alreadyJoinBtn blueGradient" @click="seeFaceCourseDetail()">查看详情</span>
                    </div>
                    <div class="signUpStatus">
                        已报名<span>123</span>/总数<span>150</span>
                    </div>

                </li>
                <li>
                    <div class="compulsoryCourseImgInfor">
                        <p class="compulsoryCourseImgTitle textCut">第一期</p>
                        <p class="compulsoryCourseScore">开课时间：2020-05-26 13:00 </p>
                        <p class="compulsoryCourseScore">授课地点：湖南省长沙市医药大学浦东校区学士路</p>
                    </div>

                    <div class="studenInterest">
                        <span class="blueGradient">立即报名</span>
                        <span class="alreadyJoinBtn blueGradient" @click="seeFaceCourseDetail()">查看详情</span>
                    </div>
                    <div class="signUpStatus">
                        已报名<span>123</span>/总数<span>150</span>
                    </div>

                </li>
            </ul>
        </div>

        <div class="compulsoryCourseCont" v-show="isShowFaceSelectClassesDetailFlag">
            <div>
                <p class="compulsoryCourseTitle">课程详情</p>
                <div class="faceCourseDetail">
                    <p>授课时间：2020-05-26 13:00至2020-05-26 17:00</p>
                    <p>报名截止时间：2020-05-26 12:00</p>
                    <p>授课地点：湖南省长沙市医药大学浦东校区学士路</p>
                    <p>公交路线：908/908区间/909（湖南中药大学站下车）</p>
                    <p style="color:red;">此处有查看地图功能，待完善</p>
                </div>
            </div>

            <div class="compulsoryCourseCont">
                <p class="compulsoryCourseTitle">课程表</p>
                <ul class="faceCourseAddressList  classScheduleList">
                    <li v-for="(item, idx) in faceCourseAddress" :key="idx">
                        <span class="classScheduleTitle textCut">{{item.address}}</span>
                        <span class="classScheduleTeacher">老师：{{item.teacher}}</span>
                    </li>
                </ul>
            </div>

            <div class="signUpNowBtn blueGradient">立即报名</div>

        </div>

    </div>

</template>
<script>
export default {
    props: {
        courseList: {
            type: Array
        },
        year_value:{
            year_value:String
        }
    },
    data () {
        return {
            isShowoOnlineCourseListFlag: true,
            faceCourseAddress: [
                {
                    'address': '湖南中医药湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学大学',
                    'teacher': '李老师'
                },

                {
                    'address': '湖南中医药大学',
                    'teacher': '李老师'
                },

                {
                    'address': '湖南中医药大学',
                    'teacher': '张张老师'
                },
                {
                    'address': '湖南中医药大学',
                    'teacher': '李老师'
                }
            ],
             isShowFaceSelcetAddressFlag: true,
            isShowFaceSelectClassesFlag: false,
            isShowFaceSelectClassesDetailFlag: false,

            isShowoOnlineCourseListFlag: true,
            isShowConfirmOnlineCourseSignUpList: false,
            isShowConfirmOnlineCourseSignUpPopFlag: false,
        }
    }
}
</script>
<style lang="stylus" scoped>
.onlineTeachingContRight
    background #fff
    /* box-shadow:0px 0px 15px 0px rgba(218,218,218,0.5);
    position:relative;
    left:-2px; */
.onlineTeachingCont
    /* overflow: hidden; */
    padding-bottom 50px
.onlineTeachingContPadding
    /* padding:50px; */
    background #fff
    border-radius 4px
.classTypesTab, .onlineConfirmSignUpBtns
    overflow hidden
    margin 0 auto
    text-align center
.classTypesTab > p
    display inline-block
    margin 0 35px
    width 110px
    height 38px
    line-height 38px
    text-align center
    color #0173ff
    font-size 16px
    letter-spacing 2px
    border 1px solid #43affc
    border-radius 4px
    cursor pointer
.onlineConfirmSignUpBtns
    margin-top 100px
.onlineConfirmSignUpBtns > p
    display inline-block
    margin 0 35px
    width 140px
    height 40px
    line-height 40px
    text-align center
    font-size 16px
    letter-spacing 2px
    border 1px solid #43affc
    border-radius 4px
    cursor pointer
.classTypesTab > p.active
    background-image -webkit-linear-gradient(left, #4bb7fc, #0173ff)
    background-image -o-linear-gradient(left, #4bb7fc, #0173ff)
    background-image -ms-linear-gradient(left, #4bb7fc, #0173ff)
    background-image linear-gradient(left, #4bb7fc, #0173ff)
    color #fff
    border none
.onlineTeachingContTop
    position relative
.classTypesSelect
    position absolute
    left 0px
    top 0
.compulsoryCourseCont
    margin-top 50px
.compulsoryCourseTitle
    font-size 18px
    color #333
    padding-left 10px
    border-left 4px solid #0173ff
    font-weight bold
.compulsoryCourseList
    margin 0 5px 0 10px
.compulsoryCourseList li
    padding 10px
    overflow hidden
    border-radius 8px
    margin-top 20px
    background rgba(255, 255, 255, 1)
    box-shadow 0px 0px 15px 0px rgba(218, 218, 218, 0.5)
    position relative
.compulsoryCourseImg img
    width 105px
    height 80px
    display block
.compulsoryCourseImgInfor
    max-width 55%
    margin-left 15px
.compulsoryCourseImgTitle
    width 100%
    color #333
    font-weight bold
.compulsoryCourseImgTitle, .compulsoryCourseScore
    margin-top 12px
.compulsoryCourseScore
    color #666
    font-size 14px
.electiveCoursesCont
    margin-top 50px
.chooseResultCont
    background rgba(228, 240, 253, 1)
    height 40px
    line-height 40px
    color #333
    text-align center
    font-size 14px
    margin-top 30px
    width 1170px
    position relative
    left -86px
.signUpNowBtn
    height 42px
    line-height 42px
    text-align center
    color #fff
    width 290px
    margin 50px auto 0
    border-radius 4px
    cursor pointer
    letter-spacing 2px
.blueGradient
    background-image -webkit-linear-gradient(left, #4bb7fc, rgb(31, 132, 255))
    background-image -o-linear-gradient(left, #4bb7fc, rgb(31, 132, 255))
    background-image -ms-linear-gradient(left, #4bb7fc, rgb(31, 132, 255))
    background-image linear-gradient(left, #4bb7fc, rgb(31, 132, 255))
    color #fff
.buttonBorderStyle
    color #0173ff
    border 1px solid #0173ff
.selectClassesList .compulsoryCourseImgInfor
    position relative
    top -6px
.signUpStatus
    position absolute
    top 25px
    color #999
    font-size 12px
    right 35px
.selectClassesList
    margin-top 40px
.faceCourseDetail
    margin 30px 30px 0 15px
.faceCourseDetail > p
    color #333
    line-height 24px
    margin-top 10px
    font-size 14px
.classScheduleTitle
    width 78%
    float left
.classScheduleTeacher
    float left
    margin-left 50px
.confirmSignUpTitle span
    margin-right 50px
.confirmSignUpTitle span font
    color #0475ff
.faceCompulsoryCourseList
.dividingLine
    height 12px
    background rgba(248, 248, 248, 1)
.onlineCourseConfirmSignUpPop
.coverLayer
    position fixed
    left 0
    right 0
    top 0
    bottom 0
    width 100%
    height 100%
    background rgba(0, 0, 0, 0.5)
.onlineCourseConfirmSignUpPopCont
    position fixed
    width 1050px
    padding 50px 35px
    box-sizing border-box
    -moz-box-sizing border-box
    left 50%
    top 50%
    transform translate(-50%, -50%)
    background #fff
    border-radius 4px
.closeBtn
    position absolute
    right 12px
    top 5px
    font-size 32px
    cursor pointer
.closeBtn:hover
    color #0475ff
</style>


// WEBPACK FOOTER //
// src/components/my/publicSignStudy/faceClass.vue